const SERVER_AI_URL = import.meta.env.VITE_SERVER_AI_URL

export const server = {

    async api(action, payload) {

        const res = await fetch(`${SERVER_AI_URL}/${action}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: payload && JSON.stringify(payload),
            credentials: 'include'
        })
            .then(res => res.json())

        console.debug(`🟡 /ai/${action}:`, payload, res)

        if (res.status === 'ok') {
            return res.data
        } else {
            throw res
        }
    }
}
